import { AnyAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "src/core/redux/store";
import { ApiError, createEvent, isApiError, SentinelLoadingStatus } from "src/core/sentinel/types";
import {submitOnboardingRequest, echo, getOnboardedTeams, getTeamPackageList, getPackageDependencyList, submitPackageDryRunUpgrades, getPackageDryRunUpgradesResult} from "src/core/sentinel/actions";
interface SentinelState {
    onboardingRequest: any;
    sentinelError: any;
    onboardedTeam: any;
    teamPackageList: any;
    dependencyList: any;
    dryRunResult: any;
  }
const initialState: SentinelState = {
    sentinelError: [],
    onboardingRequest: {
        payload: {},
        status: SentinelLoadingStatus.STARTED,
    },
    onboardedTeam: {
        payload: {},
        status: SentinelLoadingStatus.STARTED,
    },
    teamPackageList: {
        payload: {},
        status: SentinelLoadingStatus.STARTED,
    },
    dependencyList: {
        payload: {},
        status: SentinelLoadingStatus.STARTED,
    },
    dryRunResult: {
        payload: {},
        status: SentinelLoadingStatus.STARTED,
    },
};
export const SentinelSlice = createSlice({
    name: "sentinel.General",
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        dismissError: (state, action: PayloadAction<ApiError>) => {
            state.sentinelError = state.sentinelError.filter(
                (error: { message: string }) =>
                    error.message !== action.payload.message,
            );
        },
        resetOnboardingRequest: (state) => {
            state.onboardingRequest =  {
                payload: {},
                status: SentinelLoadingStatus.STARTED,
            };
        },
        resetDryRunResult: (state) => {
            state.dryRunResult = {
                payload: {},
                status: SentinelLoadingStatus.STARTED,
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(submitOnboardingRequest.pending, (state) => {
            state.onboardingRequest.status = SentinelLoadingStatus.LOADING;
        });
      
        builder.addCase(
            submitOnboardingRequest.fulfilled,
            (state, action: PayloadAction<any>) => {
                state.onboardingRequest.payload = action.payload.payload;
                state.onboardingRequest.status = action.payload.status;
            },
        );

        builder.addCase(submitOnboardingRequest.rejected, (state) => {
            state.onboardingRequest.payload = {};
            state.onboardingRequest.status = SentinelLoadingStatus.REJECTED;
        });

        builder.addCase(getOnboardedTeams.pending, (state) => {
            state.onboardedTeam.status = SentinelLoadingStatus.LOADING;
        });
      
        builder.addCase(
            getOnboardedTeams.fulfilled,
            (state, action: PayloadAction<any>) => {
                state.onboardedTeam.payload = action.payload.payload;
                state.onboardedTeam.status = action.payload.status;
            },
        );
        builder.addCase(getOnboardedTeams.rejected, (state) => {
            state.onboardedTeam.payload = {};
            state.onboardedTeam.status = SentinelLoadingStatus.REJECTED;
        });

        builder.addCase(getTeamPackageList.pending, (state) => {
            state.teamPackageList.status = SentinelLoadingStatus.LOADING;
        });
      
        builder.addCase(
            getTeamPackageList.fulfilled,
            (state, action: PayloadAction<any>) => {
                state.teamPackageList.payload = action.payload.payload;
                state.teamPackageList.status = action.payload.status;
            },
        );
        builder.addCase(getTeamPackageList.rejected, (state) => {
            state.teamPackageList.payload = {};
            state.teamPackageList.status = SentinelLoadingStatus.REJECTED;
        });


        builder.addCase(getPackageDependencyList.pending, (state) => {
            state.dependencyList.status = SentinelLoadingStatus.LOADING;
        });
      
        builder.addCase(
            getPackageDependencyList.fulfilled,
            (state, action: PayloadAction<any>) => {
                state.dependencyList.payload = action.payload.payload;
                state.dependencyList.status = action.payload.status;
            },
        );
        builder.addCase(getPackageDependencyList.rejected, (state) => {
            state.dependencyList.payload = {};
            state.dependencyList.status = SentinelLoadingStatus.REJECTED;
        });      

        builder.addCase(submitPackageDryRunUpgrades.pending, (state) => {
            state.dryRunResult.status = SentinelLoadingStatus.LOADING;
        });
        builder.addCase(
            submitPackageDryRunUpgrades.fulfilled,
            (state, action: PayloadAction<any>) => {
                state.dryRunResult.payload = action.payload.payload;
                state.dryRunResult.status = action.payload.status;
            },
        );
        builder.addCase(
            submitPackageDryRunUpgrades.rejected,
            (state) => {
                state.dryRunResult.status = SentinelLoadingStatus.STARTED;
            },
        );

        builder.addCase(getPackageDryRunUpgradesResult.pending, (state) => {
            state.dryRunResult.status = SentinelLoadingStatus.LOADING;
        });
        builder.addCase(
            getPackageDryRunUpgradesResult.fulfilled,
            (state, action: PayloadAction<any>) => {
                state.dryRunResult.payload = action.payload.payload;
                state.dryRunResult.status = action.payload.status;
            },
        );
        builder.addCase(
            getPackageDryRunUpgradesResult.rejected,
            (state) => {
                state.dryRunResult.status = SentinelLoadingStatus.STARTED;
            },
        );

        builder.addMatcher(isApiError, (state, action: AnyAction) => {
            state.sentinelError.push(action.error);
        });
    },
});

const selectSentinel = (state: RootState) => state["sentinel.General"];

export const selectOnboardingRequest = (state: RootState) => selectSentinel(state).onboardingRequest;
export const selectTeamPackageList = (state: RootState) => selectSentinel(state).teamPackageList;
export const selectPackageDependencyList = (state: RootState) => selectSentinel(state).dependencyList;
export const selectDryRunResult = (state: RootState) => selectSentinel(state).dryRunResult;
export const selectSentinelError = (state: RootState) => selectSentinel(state).sentinelError;


export const {
    dismissError,
    resetOnboardingRequest,
    resetDryRunResult,
} = SentinelSlice.actions;
export default SentinelSlice.reducer;